<template>
  <div class="banner">
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide">
        <img :src="url1" class="img" v-if="!isEnd" />
        <img :src="url3" class="img" v-if="isEnd" />
        <div class="con">
          <h3>{{$t('lang.banner.helixTitle')}}</h3>
          <div class="end" v-if="!isEnd">
            <div class="end-item">
              <div class="time">
                <span>{{ day.toString().charAt(0) }}</span>
                <span>{{ day.toString().charAt(1) }}</span>
              </div>
              <!-- <p>{{$t('lang.banner.days')}}</p> -->
            </div>
            <span class="dot">:</span>
            <div class="end-item">
              <div class="time">
                <span>{{ hour.toString().charAt(0) }}</span>
                <span>{{ hour.toString().charAt(1) }}</span>
              </div>
              <!-- <p>{{$t('lang.banner.hours')}}</p> -->
            </div>
            <span class="dot">:</span>
            <div class="end-item">
              <div class="time">
                <span>{{ min.toString().charAt(0) }}</span>
                <span>{{ min.toString().charAt(1) }}</span>
              </div>
              <!-- <p>{{$t('lang.banner.minutes')}}</p> -->
            </div>
            <span class="dot">:</span>
            <div class="end-item">
              <div class="time">
                <span>{{ second.toString().charAt(0) }}</span>
                <span>{{ second.toString().charAt(1) }}</span>
              </div>
              <!-- <p>{{$t('lang.banner.seconds')}}</p> -->
            </div>
          </div>
          <div class="alive" v-if="isEnd">
            <h3>{{$t('lang.genesis')}}</h3>
          </div>
          <div class="details hide">
            <span>{{$t('lang.banner.blockConfirmationTime')}}</span>
            <span>///</span>
            <span>{{$t('lang.banner.lowTransferFee')}}</span>
            <span>///</span>
            <span>{{$t('lang.banner.highTps')}}</span>
          </div>
          <div class="btns">
            <button
              :class="{'btn':1, 'info':1,'endbtn':isEnd}"
              @click="goto('helix')"
            >{{$t('lang.banner.moreInfoBtn')}}</button>
            <button
              v-if="isEnd"
              :class="{'btn':1, 'info':1,'endbtn':isEnd}"
              @click="gotoLink(what.dna_explorer)"
            >{{$t('lang.banner.goToExplorer')}}</button>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <img :src="url2" class="img" />
        <div class="con">
          <div class="con-intro">
            <div class="more hide">
              <p>
                <span>{{$t('lang.banner.b2t1')}}</span>
                {{$t('lang.banner.b2c1')}}
              </p>
              <p>
                <span>{{$t('lang.banner.b2t2')}}</span>
                {{$t('lang.banner.b2c2')}}
              </p>
            </div>
            <div class="dna">
              <p>{{ currentText }}</p>
              <p>{{$t('lang.banner.network')}}</p>
              <p>{{$t('lang.banner.architecture')}}</p>
            </div>
          </div>
          <button class="btn find" @click="goto('what')">{{$t('lang.banner.findOutMore')}}</button>
        </div>
      </swiper-slide>
      <!-- 左右箭头 -->
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import { what } from "../../../common/link.js";
export default {
  name: "Banner",
  data() {
    let _this = this;
    return {
      what,
      showTxtInv: 0,
      changeTxtInv: 0,
      url1: "",
      url2: "",
      swiperOption: {
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        lazy: false,
        //开启循环模式
        loop: false,
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false
        // },
      },
      //todo:prod
      curStartTime: "Fri Aug 5 2020 21:00:00 GMT+0800",
      //todo:test
      //curStartTime: "Fri Aug 5 2020 16:25:50 GMT+0800",
      isEnd: false,
      day: "00",
      hour: "00",
      min: "00",
      second: "00",
      currentText: "Dualchain",
      current: 0,
      texts: [
        "Dualchain",
        "双链",
        "Chuỗi kép",
        "โซ่คู่",
        "двойная цепь",
        "Doble cadena",
        "दोहरी श्रृंखला",
        "デュアルチェーン",
        "이중 체인",
        "Double chaîne",
      ],
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    const _this = this;
    this.swiper.on("slideChangeTransitionStart", function () {
      clearInterval(_this.showTxtInv);
      _this.current = 0;
      let txt = _this.texts[_this.current];
      _this.showText(txt);

      clearInterval(_this.changeTxtInv);
      _this.changeTxtInv = setInterval(function () {
        //console.log("changeTxtInv")
        if (_this.current == _this.texts.length - 1) {
          _this.current = 0;
        } else {
          _this.current++;
        }
        let txt = _this.texts[_this.current];
        _this.showText(txt);
      }, 3000);
    });
  },
  created() {
    this.url1 = require("../../../assets/images/banner1.jpg");
    this.url2 = require("../../../assets/images/banner2.jpg");
    this.url3 = require("../../../assets/images/banner3.png");

    // 获取当前时间
    let date = new Date();
    // 设置截止时间
    let endDate = new Date(this.curStartTime); // this.curStartTime需要倒计时的日期
    if (date > endDate) {
      this.isEnd = true;
    }
    this.countTime();
    const _this = this;
    clearInterval(_this.changeTxtInv);
    _this.changeTxtInv = setInterval(function () {
      if (_this.current == _this.texts.length - 1) {
        _this.current = 0;
      } else {
        _this.current++;
      }
      let txt = _this.texts[_this.current];
      _this.showText(txt);
    }, 3000);
  },
  methods: {
    // 特效显示
    showText(txt) {
      //console.log("showText:"+txt)
      const _this = this;
      let length = txt.length;
      let time = length * 100;
      time = time > 800 ? 800 : time;
      let cur = 0;
      clearInterval(_this.showTxtInv);
      _this.currentText = "";
      _this.showTxtInv = setInterval(() => {
        //console.log("showTxtInv:"+txt)
        _this.currentText = _this.currentText + txt[cur];
        cur++;
        if (cur >= length) {
          clearInterval(_this.showTxtInv);
        }
      }, time / length);
    },
    // 倒计时
    countTime() {
      // 获取当前时间
      let date = new Date();
      let now = date.getTime();
      // 设置截止时间
      let endDate = new Date(this.curStartTime); // this.curStartTime需要倒计时的日期
      let end = endDate.getTime();
      // 时间差
      let leftTime = end - now;
      //console.log("leftTime:" + leftTime);
      // 定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 1000) {
        // 天
        let day = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        this.day = day < 10 ? "0" + day : day;
        // 时
        let h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.hour = h < 10 ? "0" + h : h;
        // 分
        let m = Math.floor((leftTime / 1000 / 60) % 60);
        this.min = m < 10 ? "0" + m : m;
        // 秒
        let s = Math.floor((leftTime / 1000) % 60);
        this.second = s < 10 ? "0" + s : s;
      } else {
        this.day = "00";
        this.hour = "00";
        this.min = "00";
        this.second = "00";
        this.isEnd = true;
      }
      // 等于0的时候不调用
      if (
        Number(this.hour) === 0 &&
        Number(this.day) === 0 &&
        Number(this.min) === 0 &&
        Number(this.second) === 0
      ) {
        return;
      } else {
        // 递归每秒调用countTime方法，显示动态时间效果,
        setTimeout(this.countTime, 1000);
      }
    },
    goto(url) {
      this.status = url;
      switch (url) {
        case "what":
          if (this.$route.name == "BuildWhat") {
            this.$emit("scroll", "");
          } else {
            this.$router.push({ name: "BuildWhat", params: { id: "what" } });
          }
          break;
        case "helix":
          if (this.$route.name == "BuildWhat") {
            this.$emit("scroll", "helix");
          } else {
            this.$router.push({ name: "BuildWhat", params: { id: "helix" } });
          }
          break;
        default:
          break;
      }
    },
    gotoLink(url) {
      if (!url) {
        this.$message.info({
          message: this.$t("lang.comingsoon"),
          duration: 800,
        });
        return;
      }
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~css/mixins.styl';
@import '~css/varibles.styl';

.banner {
  overflow: hidden;
  width: 100%;
  height: 0;
  padding-bottom: 31.25%;
  background-color: #161536;
  min-height: 422px;

  .img {
    width: auto;
    max-width: 100%;
    min-height: 422px;
    margin: 0 auto;
  }

  .con {
    position: absolute;
    top: 0;
    left: 50%;
    width: 12rem;
    height: 100%;
    min-height: 422px;
    padding-top: 0.64rem;
    padding-bottom: 0;
    margin: 0 0 0 -6rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .find {
      width: 3.15rem;
      height: 0.6rem;
      margin-left: 3%;
    }

    h3 {
      font-size: 0.48rem;
      color: $white;
      text-align: center;
      margin-bottom: 0.3rem;
      font-weight: 800;
      font-family: Helvetica;
    }

    .end {
      margin: 0 10%;
      center();
      justify-content: center;
      height: 1rem;
      border-radius: 3px;

      .dot {
        font-size: 0.48rem;
        color: $white;
        margin-top: -0.2rem;
      }

      .end-item {
        margin: 0 0.3rem;
        text-align: center;
      }

      .time {
        font-size: 0.43rem;

        span {
          display: inline-block;
          width: 0.59rem;
          height: 0.81rem;
          line-height: 0.85rem;
          font-weight: 800;
          color: $dark;
          background: url('../../../assets/images/timebg.png') center center no-repeat;
          background-size: 100% auto;
          text-align: center;
          font-family: Helvetica;

          &:first-child {
            margin-right: 0.05rem;
          }
        }
      }

      p {
        font-size: 0.14rem;
        margin-top: 0.15rem;
        color: $white;
        text-align: center;
      }
    }

    .alive {
      margin: 0 10%;
      center();
      justify-content: center;
      height: 1rem;
    }

    .details {
      center();
      justify-content: space-around;
      margin-top: 0.4rem;

      span {
        text-align: center;
        color: $white;
        font-size: 0.18rem;
      }
    }

    .btns {
      margin: 0.6rem auto 0;

      .info {
        display: block;
        width: 3.02rem;
        height: 0.46rem;
        line-height: 0.46rem;
        color: $white;
        border: 1px solid $white;

        &:hover {
          color: $btnColor;
          background-color: $white;
        }

        &.endbtn {
          display: inline;

          &:first-child {
            margin-right: 0.2rem;
          }

          &:last-child {
            margin-left: 0.2rem;
          }
        }
      }
    }
  }

  .con-intro {
    center();
    margin: 0 3% 0.1rem;

    .more {
      margin-right: 15%;

      p {
        font-size: 0.2rem;
        line-height: 0.24rem;
        color: $dark;

        &:first-child {
          margin-bottom: 0.3rem;
        }

        span {
          font-weight: 800;
          font-family: Helvetica;
        }
      }
    }

    .dna {
      p {
        font-size: 0.58rem;
        line-height: 0.72rem;
        height: 0.72rem;
        overflow: hidden;
        color: $dark;
        font-weight: 800;
        font-family: Helvetica;
        min-width: 4.8rem;
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .banner {
    padding-bottom: 0;
    height: 200px;
    min-height: 200px;

    .img {
      height: 200px;
      min-height: 200px;
    }

    .con {
      min-height: 200px;

      .find {
        display: block;
        margin: 10px auto 0;
      }

      h3 {
        font-size: 16px;
        margin-top: 10px;
      }

      .end {
        height: 62px;
        margin: 0 5%;

        .time {
          span {
            width: 19px;
            height: 27px;
            line-height: 30px;
          }
        }
      }

      .btns {
        text-align: center;

        .info {
          &.endbtn {
            margin: 0.2rem;
          }
        }
      }
    }

    .con-intro {
      justify-content: center;

      .dna {
        p {
          font-size: 16px;
          height: 28px;
          line-height: 28px;
          text-align: center;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/home/components/Banner.vue